import axios from "axios";
export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const WEBSOCKET_URL = process.env.REACT_APP_WS_URL;
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    Accept: "application/json",
  },
});
  api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); 

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function resolveMediaLicence(path, fallback = "") {
  if (!path) return fallback;

  if (!path.includes("/")) {
    return `${API_BASE_URL}/images/driverLicence/${path}`;
  }
  return `${API_BASE_URL}/${path.replace(/^\/+/, "")}`;
}
export function resolveMediaCarType(path, fallback = "") {
  if (!path) return fallback;

  if (!path.includes("/")) {
    return `${API_BASE_URL}/images/carType/${path}`;
  }
  return `${API_BASE_URL}/${path.replace(/^\/+/, "")}`;
}


export function resolveMediaCar(path, fallback = "") {
  if (!path) return fallback;

  if (!path.includes("/")) {
    return `${API_BASE_URL}/images/car/${path}`;
  }
  return `${API_BASE_URL}/${path.replace(/^\/+/, "")}`;
}
export function resolveMedia(path, fallback = "") {
  if (!path) return fallback;

  if (!path.includes("/")) {
    return `${API_BASE_URL}/images/user/${path}`;
  }
  return `${API_BASE_URL}/${path.replace(/^\/+/, "")}`;
}


export function resolveMediaCarBrand(path, fallback = "") {
  if (!path) return fallback;

  if (!path.includes("/")) {
    return `${API_BASE_URL}/images/carBrand/${path}`;
  }
  return `${API_BASE_URL}/${path.replace(/^\/+/, "")}`;
}

export default api;
